import { RiDownloadCloud2Line, RiLineChartLine, RiMenuLine } from 'react-icons/ri';
import { Link, useLocation } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { MenuButton, MenuItemContainer } from '../styles';
import { TbFileSettings } from 'react-icons/tb';
import { FiUpload } from 'react-icons/fi';

interface MenuListProps {
  extendedMode: boolean;
  setExtendedMode?: (val: boolean) => void;
}

export const CreatorMenuList = ({ extendedMode }: MenuListProps) => {
  const location = useLocation();

  const tooltipProps = {
    tooltip: {
      sx: {
        backgroundColor: "var(--dark-gray)",
        color: "var(--white)",
        fontSize: "14px",
        fontWeight: "500",
        padding: "8px 14px",
        borderRadius: "6px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
      }
    },
    arrow: {
      sx: {
        color: "var(--dark-gray)"
      }
    }
  };

  return (
    <>
      <MenuItemContainer>
        <Link to="/creators/dashboard">
          <Tooltip 
            title={extendedMode ? "" : "Relatórios"} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/creators/dashboard")}>
                <div className="content">
                  <RiLineChartLine size={24} />
                  <span>Relatórios</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/creators/solutions">
          <Tooltip 
            title={extendedMode ? "" : "Soluções"} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/creators/solutions")}>
                <div className="content">
                  <RiDownloadCloud2Line size={24} />
                  <span>Soluções</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/creators/orders">
          <Tooltip 
            title={extendedMode ? "" : "Pedidos"} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/creators/orders")}>
                <div className="content">
                  <RiMenuLine size={24} />
                  <span>Pedidos</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/creators/standard-solutions">
          <Tooltip 
            title={extendedMode ? "" : "Padronizadas"} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} 
isActive={location.pathname.includes("/creators/standard-solutions")}>
                <div className="content">
                  <TbFileSettings size={24} />
                  <span>Padronizadas</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/creators/multi-standard-solutions-upload">
          <Tooltip 
            title={extendedMode ? "" : "Multi Upload"} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} 
isActive={location.pathname.includes("/creators/multi-standard-solutions-upload")}>
                <div className="content">
                  <FiUpload size={24} />
                  <span>Multi Upload</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>
    </>
  );
};